module.exports = "/assets/dist/img/list-bullet.png?8acff754b37b8aa07c0928ba4b81cc7b";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/pictureday/home/index/assets/list-bullet.png
// module id = 2045
// module chunks = 9